import { Flex, Label, Link, Span, styled } from '@fareye/ui'
import { cancelToken, get } from '@fareye/utils'
import { TOKEN_KEY } from 'config/app'
import React from 'react'
import { useTranslation } from '@fareye/common'
import { FaUserCircle } from 'react-icons/fa'
import { withRouter } from 'react-router'
import { RoutesPath } from '../../config/constants'
import { AppIcon, HeaderDiv, LogoutIcon, MenuIcon } from '../../style/styled'
import { IHeaderProps } from '../../utility/types'
import { AppStore } from './../../store'
import Language from './Language'
import TimeZone from './TimeZone'

const source = cancelToken().source()

export const UserProfileMenu: any = styled.div`
  right: 0px;
  padding: 5px 0;
  min-width: 155px;
  background: #fff;
  border-radius: 4px;
  position: absolute;
  top: 100%;
  flex-direction: column;
  box-shadow: 0 1px 5px rgba(204, 204, 204);
  a,
  span {
    padding: 7px 15px;
    border-radius: 0;
    transition: 0.6s ease;
    justify-content: flex-start;
    color: ${(props: any) => props.bg || props.theme.colors.primary};
    > svg {
      transition: 0.6s ease;
      margin-right: 10px;
      color: ${(props: any) => props.bg || props.theme.colors.primary};
    }
    &.active,
    &:hover {
      background: ${(props: any) => props.bg || props.theme.colors.primary};
      color: #fff;
      transition: 0.8s ease;
      > svg {
        transition: 0.8s ease;
        color: #fff;
      }
      > div {
        display: flex;
        opacity: 1;
        transition: 0.6s ease;
      }
    }
  }
  span {
    padding: 7px;
  }
`

export const UserMenuLink = styled.div`
  position: relative;
  $:hover {
  }
  > span {
    cursor: pointer;
    padding: 7px;
    display: flex;
    align-items: center;
    label {
      cursor: pointer;
      text-transform: capitalize;
      font-weight: 600;
      color: #fff;
    }
  }
`
function Header(props: IHeaderProps) {
  const { setMenuOpen, history } = props
  const { t } = useTranslation()
  // Need to implement properly through elements rather than body
  // document.body.dir = i18n.dir()
  const { store, updateStore } = React.useContext(AppStore)
  const isAuthenticated = localStorage.getItem(TOKEN_KEY)
  const [menuToggle, setMenuToggle] = React.useState(false)
  const hideTopNavigation = new URL(document.location.href).searchParams.get(
    'disableNav'
  )
  const { i18n } = useTranslation()

  async function getUserProfile(newStore?: any) {
    try {
      const { data, status } = await get('/api/v1/profile', source.token, {
        headers: { 'Key-Inflection': 'camel', 'X-Change-Case': true }
      })
      updateStore({
        ...newStore,
        header: {
          ...newStore.header,
          userProfile: status === 200 ? data.profile : {}
        }
      })
      if (data?.profile?.locale) {
        i18n.changeLanguage(data?.profile?.locale)
      }
    } catch (err) {
      console.error(err)
    }
  }

  React.useEffect(() => {
    if (isAuthenticated) {
      getUserProfile({
        ...store,
        header: {
          ...store.header,
          getUserProfile
        }
      })
    }
  }, [])

  if (hideTopNavigation) {
    return null
  }
  const { userProfile, backgroundColor, img } = store?.header || {}
  const { lastName, firstName } = userProfile || {}
  const name = `${firstName || ''} ${lastName || ''}`.trim() || 'Guest'
  const bg = backgroundColor || '#006490'
  return (
    <HeaderDiv justifyContentSpaceBetween data-testid="app-header" bg={bg}>
      <Flex>
        <MenuIcon onClick={setMenuOpen} />
        <AppIcon src={img} alt="fareye-logo" />
      </Flex>
      <UserMenuLink data-testid="user-menu">
        <Span
          data-testid="user-name"
          onClick={(e: any) => {
            e.preventDefault()
            setMenuToggle(!menuToggle)
          }}
        >
          <Label>
            {t('hi')}! {name}
          </Label>
        </Span>
        {menuToggle ? (
          <UserProfileMenu bg={bg}>
            <Link to={RoutesPath.PROFILE}>
              <FaUserCircle size={20} />
              {t('Profile')}
            </Link>
            <TimeZone bg={bg} />
            <Language />
            <Link data-testid="logout" to={RoutesPath.LOGOUT}>
              <LogoutIcon size={18} />
              {t('Logout')}
            </Link>
          </UserProfileMenu>
        ) : null}
      </UserMenuLink>
    </HeaderDiv>
  )
}
export default withRouter(Header)
